const testEnvironments = [
    'grandvision.io',
    'localhost'
];
const debugHostname = (hostname)=>{
    return testEnvironments.some((env)=>hostname.includes(env)
    );
};
const shouldBypassConsent = ()=>typeof window !== 'undefined' && debugHostname(window.location.hostname) && !isDebugEnabled(window)
;
const isDebugEnabled = (window)=>{
    try {
        return !!localStorage.getItem('gv:debug:cookie-consent') || window.location.pathname.includes('cookie-consent-debug');
    } catch (error) {
        console.error('Error accessing debug flag in localStorage:', error);
        return false;
    }
};

export { debugHostname, isDebugEnabled, shouldBypassConsent, testEnvironments };
//# sourceMappingURL=debug.js.map
